import { gql } from '@apollo/client';

const NEW_REPORT_DATA_STUDY_QUERY = gql`
  query study($id: ID!) {
    study(id: $id) {
      id
      reports {
        type
        status
      }
    }
  }
`;

export default NEW_REPORT_DATA_STUDY_QUERY;
